import React, { createContext, useState, useCallback } from 'react';
import { toast } from 'react-toastify';
import { getPosts, createPost, updatePost, deletePost, getCategories } from '../services/api';

export const BlogPostContext = createContext();

export const BlogPostProvider = ({ children }) => {
  const [posts, setPosts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchPosts = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getPosts();
      setPosts(response.data);
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'خطا در دریافت پست‌ها';
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchCategories = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getCategories();
      setCategories(response.data);
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'خطا در دریافت دسته‌بندی‌ها';
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  }, []);

  const addPost = useCallback(async (formData) => {
    setLoading(true);
    setError(null);
    try {
      const response = await createPost(formData);
      setPosts((prev) => [...prev, response.data]);
      toast.success('پست با موفقیت اضافه شد');
      return response.data;
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'خطا در افزودن پست';
      setError(errorMessage);
      toast.error(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const editPost = useCallback(async (id, formData) => {
    setLoading(true);
    setError(null);
    try {
      const response = await updatePost(id, formData);
      setPosts((prev) => prev.map((post) => (post.id === id ? response.data : post)));
      toast.success('پست با موفقیت به‌روزرسانی شد');
      return response.data;
    } catch (err) {
      const errorMessage =
        err.response?.status === 404
          ? 'پست مورد نظر یافت نشد'
          : err.response?.data?.message || 'خطا در به‌روزرسانی پست';
      setError(errorMessage);
      toast.error(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const removePost = useCallback(async (id) => {
    setLoading(true);
    setError(null);
    try {
      await deletePost(id);
      setPosts((prev) => prev.filter((post) => post.id !== id));
      toast.success('پست با موفقیت حذف شد');
    } catch (err) {
      const errorMessage =
        err.response?.status === 404
          ? 'پست مورد نظر یافت نشد'
          : err.response?.data?.message || 'خطا در حذف پست';
      setError(errorMessage);
      toast.error(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return (
    <BlogPostContext.Provider
      value={{
        posts,
        categories,
        loading,
        error,
        fetchPosts,
        fetchCategories,
        addPost,
        editPost,
        removePost,
      }}
    >
      {children}
    </BlogPostContext.Provider>
  );
};